<template>
<loader v-bind="{ loading }">

</loader>  
</template>
<script>
export default {
  
  data: () => ({
    loading: true
  })

}
</script>